import { useMemo } from 'react'

const defaultLocale = 'pl-PL'

const useLocale = (detect = false) => {
  return useMemo(() => {
    let locale
    if (detect) {
      locale =
        (typeof navigator !== 'undefined'
          ? navigator.language || navigator.userLanguage
          : undefined) ?? defaultLocale
    } else {
      locale = defaultLocale
    }
    return {
      default: defaultLocale,
      locale,
    }
  }, [detect])
}

export default useLocale
